import { Suspense } from 'react';
import { Loading } from '../Loading';

export type LoaderProps = {
	children: React.ReactNode;
	noMargin?: boolean;
	noContainer?: boolean;
	className?: string;
	title?: string;
};

/**
 * This component is a bit of mess. This is for debugging suspense issues.
 * Switch the commented out fallback prop for the uncommented one to use.
 */
export const Loader: React.FC<LoaderProps> = ({
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	noMargin,
	noContainer,
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	className,
	children,
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	title
}) => {
	return (
		<Suspense
			// fallback={<Alert title={title} />}
			fallback={
				<div
					className={`loader${
						noContainer ? '' : ' loading-container'
					}${className ? ` ${className}` : ''}`}
				>
					<div className="mt-3">
						<Loading />
					</div>
				</div>
			}
		>
			{children}
		</Suspense>
	);
};
